class CartRecommendationsComponent extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		new IntersectionObserver(this.init.bind(this)).observe(this);
	}

	init(entries, observer) {
		if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('cart-recommendations-component');
				const items = recommendations.querySelectorAll('.f-cart-recommendations__item');
				const wrapper = recommendations.querySelector('.f-cart-recommendations__wrapper');
				if (wrapper && items.length > 0) {
					wrapper.classList.remove('hidden')
				} else {
					wrapper.classList.add('hidden')
				}

				if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
			}).catch(err => console.error(err))
	}
}

customElements.define('cart-recommendations-component', CartRecommendationsComponent)